import { Box, useTheme } from "@mui/material";
import { isAppInPDFMode } from "src/utils/rendering";
import { t } from "i18next";

export type PageBreakProps = {
    showInEditor?: boolean;
};

const PAGE_BREAK_MARKER_CLASS = "puck-page-break";

export const PageBreak = (props: PageBreakProps) => {
    const { showInEditor = true } = props;
    const theme = useTheme();

    const isPdfMode = isAppInPDFMode();
    return (
        <Box
            className={PAGE_BREAK_MARKER_CLASS}
            data-page-break="true"
            sx={{
                width: "100%",
                position: "relative",
                breakAfter: "page",
                pageBreakAfter: "always",
                "@media print": {
                    breakAfter: "page",
                    pageBreakAfter: "always",
                },
                "@media screen": {
                    display:
                        isPdfMode ? "block"
                        : showInEditor ? "block"
                        : "none",
                    minHeight:
                        isPdfMode ? 0
                        : showInEditor ? "48px"
                        : 0,
                },
            }}
        >
            {!isPdfMode && showInEditor && (
                <Box
                    sx={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        height: "48px",
                        borderTop: `2px dashed ${theme.palette.primary.main}`,
                        borderBottom: `2px dashed ${theme.palette.primary.main}`,
                        backgroundColor: theme.palette.action.hover,
                        "&::before": {
                            content: `"${t("puck.blocks.page_break.label", "Page Break")}"`,
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            backgroundColor: theme.palette.background.paper,
                            padding: theme.spacing(0.5, 2),
                            borderRadius: theme.shape.borderRadius,
                            color: theme.palette.primary.main,
                            fontSize: "12px",
                            fontWeight: 600,
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                            fontFamily: "Montserrat",
                            border: `1px solid ${theme.palette.primary.main}`,
                        },
                    }}
                />
            )}
        </Box>
    );
};

export { PAGE_BREAK_MARKER_CLASS };
